import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';
import { ScriptNames, scriptRegistry } from '../enum/schema';

@Injectable({
  providedIn: 'root',
})
export class SeoScriptsService {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.setupSchemaScriptInHead();
  }

  setupSchemaScriptInHead() {
    this.addJsonLd(ScriptNames.org, scriptRegistry[ScriptNames.org]);
    if (isPlatformBrowser(this.platformId)) {
      // For client-side rendering - subscribe to route changes
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          map((event: NavigationEnd) => {
            let current = this.route.root;
            while (current.firstChild) current = current.firstChild;
            if(event?.urlAfterRedirects?.includes('contact-us')){
              return ScriptNames.local;
            }
            return current.snapshot.data['seoScript'] || null;
          })
        )
        .subscribe((scriptId: string | null) => {
          if (scriptId) {
            console.log(scriptId);
            this.fetchRouteScriptDataAndSetInHead(scriptId);
          }else if(true){

          }
           else {
            this.clearAllJsonLd();
            this.addJsonLd(ScriptNames.org, scriptRegistry[ScriptNames.org]);
          }
        });
    } else if (isPlatformServer(this.platformId)) {
      // For server-side rendering - set once based on initial route
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          take(1), // Take only the first NavigationEnd event on the server
          map(() => {
            let current = this.route.root;
            while (current.firstChild) current = current.firstChild;
            return current.snapshot.data['seoScripts'] || [];
          })
        )
        .subscribe((scriptId: string | null) => {
          if (scriptId) {
            this.fetchRouteScriptDataAndSetInHead(scriptId);
          } else {
            this.clearAllJsonLd();
            this.addJsonLd(ScriptNames.org, scriptRegistry[ScriptNames.org]);
          }
        });
    }
  }

  fetchRouteScriptDataAndSetInHead(scriptId: string) {
    this.clearAllJsonLd();
    this.addJsonLd(ScriptNames.org, scriptRegistry[ScriptNames.org]);
    this.addJsonLd(scriptId, scriptRegistry[scriptId]);
  }

  addJsonLd(id: string, json: Record<string, any>): void {
    // Avoid duplicates
    if (this.document.getElementById(id)) return;

    const script = this.document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.text = JSON.stringify(json);
    this.document.head.appendChild(script);
  }

  addFullScriptForStoreCategory(jsMetaData: string) {
    const id = 'store-category-schema';
    this.removeJsonLd(id);
    const template = this.document.createElement('template');
    template.id = id;
    template.innerHTML = jsMetaData.trim();
    const scriptEl = template.content.firstElementChild;
    document.head.appendChild(scriptEl);
  }

  removeJsonLd(id: string): void {
    const script = this.document.getElementById(id);
    if (script) {
      this.document.head.removeChild(script);
    }
  }

  clearAllJsonLd(): void {
    const scripts = this.document.querySelectorAll(
      'script[type="application/ld+json"]'
    );
    scripts.forEach((script) => {
      this.document.head.removeChild(script);
    });
  }
}
